var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPolygomDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_polygom_dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5858 5.82843C14.3668 5.04738 15.6332 5.04738 16.4142 5.82843C16.7893 6.2035 17 6.71221 17 7.24264V13C17 13.0565 17.0047 13.1119 17.0137 13.1659C15.8414 13.5739 15 14.6887 15 16C15 17.6569 16.3431 19 18 19C19.6569 19 21 17.6569 21 16C21 14.6887 20.1586 13.5739 18.9863 13.1659C18.9953 13.1119 19 13.0565 19 13V7.24264C19 6.18178 18.5786 5.16436 17.8284 4.41422C16.2663 2.85212 13.7337 2.85212 12.1716 4.41422C11.4214 5.16436 11 6.18178 11 7.24264V16.7574C11 17.2878 10.7893 17.7965 10.4142 18.1716C9.63317 18.9526 8.36683 18.9526 7.58579 18.1716C7.21071 17.7965 7 17.2878 7 16.7574V11C7 10.9435 6.99531 10.8881 6.9863 10.8341C8.15864 10.4262 9 9.31134 9 8C9 6.34315 7.65685 5 6 5C4.34315 5 3 6.34315 3 8C3 9.31134 3.84136 10.4262 5.0137 10.8341C5.00469 10.8881 5 10.9435 5 11V16.7574C5 17.8182 5.42143 18.8356 6.17157 19.5858C7.73367 21.1479 10.2663 21.1479 11.8284 19.5858C12.5786 18.8356 13 17.8182 13 16.7574V7.24264C13 6.71221 13.2107 6.2035 13.5858 5.82843ZM7 8C7 8.55229 6.55228 9 6 9C5.44772 9 5 8.55229 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8ZM19 16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPolygomDark);
export default __webpack_public_path__ + "static/media/ic_action_polygom_dark.916a58574e87250caf94f0237de5d3d1.svg";
export { ForwardRef as ReactComponent };